import { useQuery } from 'react-query';

import { ENDPOINT_DISCOUNT_CLASSES } from '@/common/constants';
import getDiscountClasses from '@/materiaux/api/discount/getDiscountClasses';

const useDiscountClasses = () =>
  useQuery([ENDPOINT_DISCOUNT_CLASSES], getDiscountClasses);

export default useDiscountClasses;
